import React from 'react';
import {CssVarsKeys} from '../../../baseCustomCssVars';
import {IGalleryGlobalProps} from '../../../gallery/galleryGlobalStrategy';
import {useStylesParams} from '../../../stylesParamsContext';
import {useEnvironment} from '@wix/yoshi-flow-editor';
import {useAllStyles} from '../../../allStylesContext';

type ConditionalRenderProps = {
  by: Partial<CssVarsKeys>;
  dataHook?: string;
} & Omit<React.HTMLProps<HTMLDivElement>, 'style'> &
  IGalleryGlobalProps;

export const ConditionalRender: React.FunctionComponent<ConditionalRenderProps> = ({
  by,
  className,
  dataHook,
  children,
  ...props
}: ConditionalRenderProps) => {
  const stylesParams = useStylesParams();
  const {stylesForAllBreakpoints, customCssVarsForAllBreakpoints} = useAllStyles();
  const {isEditor} = useEnvironment();

  const shouldRender = () => {
    if (by in stylesParams) {
      return stylesForAllBreakpoints.some((stylesPerBreakpoint) => stylesPerBreakpoint.booleans[by]);
    }

    return customCssVarsForAllBreakpoints.some((stylesPerBreakpoint) => stylesPerBreakpoint[by]);
  };

  if (!isEditor && !shouldRender()) {
    return null;
  }

  const style: React.CSSProperties = {
    display: `var(--${by.replace(':', '-')}-display, inherit)`,
  };

  return (
    <div className={className} data-hook={dataHook} style={style} {...props}>
      {children}
    </div>
  );
};
